import React, { useState, useEffect, useRef, useCallback } from "react";
import { useSelector, useDispatch } from 'react-redux';
import { closeModal } from "../../../../redux/actions/action-creator";
import { Link } from 'react-router-dom';

const SummaryType = (props) => {
  const dispatch = useDispatch();
 
  const [all_data, setAllData] = useState([
    { id: 'item_wise', name: 'Item-Wise' },
    { id: 'group_wise', name: 'Group-Wise' },
    { id: 'category_wise', name: 'Category-Wise' },
    { id: 'company_wise', name: 'Company-Wise' },
  ])
  const [selectedItem, setSelectedItem] = useState(0);
  const boxRef = useRef(null)

  useEffect(() => {
    if (props.setLoading) {
      props.setLoading(false);
    }
  }, []);

  const handleKeyDown = useCallback((e) => {
    if (e.key === 'ArrowUp') {
      e.preventDefault();
      setSelectedItem(prevState => Math.max(prevState - 1, 0));
    } else if (e.key === 'ArrowDown') {
      e.preventDefault();
      setSelectedItem(prevState => Math.min(prevState + 1, all_data.length - 1));
    } else if (e.key === 'Enter') {
      e.preventDefault();
      const selected = all_data[selectedItem];
      if (selected) {
        props.setDate({ ...props.date, filter_name: selected.name });
        dispatch(closeModal('summaryType'));
      }
    } else if (e.key === 'Escape') {
      e.preventDefault();
      dispatch(closeModal('summaryType'));
    }
  }, [selectedItem, all_data, dispatch, props.date, props.setDate])

  useEffect(() => {
    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [handleKeyDown]);

  return (
    <div className='my-card'>
      <div className='cross_button' onClick={() => dispatch(closeModal('summaryType'))}>
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-x" viewBox="0 0 16 16">
          <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
        </svg>
      </div>
      <div className='container'>
        <div className="row justify-content-center mt-4">
          <div className='col-4 border bg-light border-dark' style={{ height: '300px', overflowY: 'auto' }}>
            <div className='row background' style={{ height: 30 }}>
              <div className='col-12 text-center'>
                <p className='m-0'>Summary Type</p>
              </div>
            </div>
            <div className='row mt-1 border-top border-secondary' ref={boxRef} >
              {all_data.map((item, index) => (
                <div
                  className={`col-12 p-1 dropdown_link ${index === selectedItem ? 'selected' : ''}`}
                  key={item.id}
                  onClick={() => {
                    setSelectedItem(index);
                    props.setDate({ ...props.date, filter_name: item.name });
                    dispatch(closeModal('summaryType'));
                  }}
                >
                  <Link className="ps-2" style={{ textDecoration: 'none', color: 'inherit' }}>
                    {item.name}
                  </Link>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
export default SummaryType;